<template>
  <div
    :key="$route.params.chat_id"
    style="height: 100%; position: relative"
    ref="chatContent"
  >
    <div class="chat-background">
      <template v-if="!background_images">
        <template v-if="background_image_url_state">
          <img class="bg_image" :src="background_image_url_state" />
        </template>
        <template v-else>
          <img
            class="bg_image"
            :src="require('@/assets/static/images/bg/' + background_image)"
          />
        </template>
        <div class="chat-background__overlay"></div>
      </template>
    </div>
    <div
      class="chats-content"
      :class="{ 'chats-content--light-blue': background_image === 'Light Blue' }"
    >
      <div class="chat" ref="chatContainer" :key="$route.params.chat_id + 1">
        <div class="chat__top">
          <p v-if="chat.support">
            {{ chat.auth == getUserData._id ? localName : $t("support") }}
          </p>
          <input
            v-else
            ref="chatNameInput"
            class="chat-rename-input"
            v-model="localName"
            type="text"
            @blur="saveNewName"
            @keypress.exact.enter="removefocus"
          />
          <div class="chat__top__flex">
            <button
              @click="muteOrUnmute"
              :style="chat.support ? '' : 'margin-right: 14px'"
              :title="mute.text"
            >
              <div
                v-if="mute.text == this.$t('list.mute')"
                style="display: flex; align-items: center"
              >
                <img
                  width="20px"
                  height="15px"
                  :src="require('@/assets/static/images/volume.svg')"
                  alt=""
                />
              </div>
              <div v-else style="display: flex; align-items: center">
                <img
                  width="20px"
                  height="13px"
                  :src="require('@/assets/static/images/mute.svg')"
                  alt=""
                />
              </div>
            </button>
            <template v-if="!chat.support">
              <div class="link">
                <button
                  @click="removeProjectChats"
                  v-if="chat.project_id"
                  :disabled="linkListChatSubmitting"
                  title="Unlink"
                >
                  <img
                    width="17px"
                    height="10px"
                    :src="require('@/assets/static/images/unlink.svg')"
                    alt="Unlink"
                  />
                </button>
                <button
                  @click="addProjectChats"
                  v-else
                  :disabled="linkListChatSubmitting"
                  title="Link to list"
                >
                  <img
                    width="17px"
                    height="10px"
                    :src="require('@/assets/static/images/link.svg')"
                    alt="Link to list"
                  />
                </button>
              </div>
              <button @click="openBar(chat._id)" title="Members">
                <img
                  v-if="show_member"
                  width="18px"
                  height="12px"
                  :src="require('@/assets/static/images/share_blue.svg')"
                  alt="open bar"
                />
                <img
                  v-else
                  width="18px"
                  height="12px"
                  :src="require('@/assets/static/images/share.svg')"
                  alt="open bar"
                />
              </button>
            </template>
          </div>
        </div>
        <div class="chat__content comments comments_chat">
          <Comments
            :key="$route.params.chat_id"
            :date="chat.date"
            :author="chat.auth"
            :type="'chat'"
          />
          <AddComment :key="chat._id + 1" :type="'chat'" :id="chat._id" />
        </div>
      </div>
      <Transition :name="chatBarAnimationName">
        <div class="chat_bar" :style="style" v-if="hasProject" key="79898a2">
          <div
            class="resize-trigger"
            id="resizeTrigger"
            @click.prevent.stop="() => {}"
            @mousedown.prevent.stop="handleStartResize"
          ></div>
          <div
            class="chat-sidebar-container"
            :class="{ flexibleMaxWidth: chat.project_id }"
          >
            <Transition :name="animationName" @after-enter="afterTransition">
              <div class="task_body" key="5546564" v-if="$route.params.task_id">
                <TaskBody :chatPage="true" />
              </div>
              <div
                class="project"
                ref="tasksList"
                key="dasdasdasjd"
                v-else-if="chat.project_id"
              >
                <div class="project_title">
                  <RenameElement
                    v-if="project"
                    :id="chat.project_id"
                    :name="project.name"
                    :type="'project'"
                  />
                </div>
                <Tasks
                  class="vertical_scrollbar"
                  v-if="project"
                  :chat_id="chat._id"
                  :project_id="chat.project_id"
                  :project_name="project.name"
                />
              </div>
            </Transition>
          </div>
        </div>
      </Transition>
      <Transition name="extend-width">
        <div
          class="members"
          ref="members"
          :style="show_member ? 'display: block' : 'display: none'"
          key="lkjlkj"
        >
          <div class="members__title">
            <div>
              <img
                width="18px"
                height="12px"
                :src="require('@/assets/static/images/share_black.svg')"
                alt="open bar"
                class="share"
              />
              {{
                $tc("chat.members", Number(chat.user_length), {
                  count: chat.user_length,
                })
              }}
            </div>
            <img
              @click="addUser"
              title="Members"
              width="15px"
              height="15px"
              :src="require('@/assets/static/images/add_member.svg')"
              alt="Add member"
              class="add_member"
            />
          </div>
          <div class="members__lists" style="display: flex; flex-wrap: wrap">
            <div
              v-for="(user, i) of users"
              :key="user.user_id"
              :ref="'chat_user' + i"
              style="width: 100%"
              class="members__for"
            >
              <div class="members__list">
                <div
                  class="members__list__avatar"
                  :style="'background-color:' + user.user_data.color"
                  v-html="$w_user_image(user.user_data)"
                ></div>
                <div class="members__list__name">
                  <div
                    v-if="isChatOwner(user.user_id)"
                    class="owner"
                    key="65465"
                  >
                    <p>{{ user.user_data.name }}</p>
                    <span class="owner_text">{{ $t("chat.owner") }}</span>
                  </div>
                  <div v-else key="32132">
                    <p>{{ user.user_data.name }}</p>
                  </div>
                  <span
                    :id="'user_' + user.user_id"
                    :style="
                      user.last_seen != 'Online'
                        ? 'color: #8C8A8A;text-transform: lowercase'
                        : ''
                    "
                  >
                    {{
                      getPlan.show_online == "on"
                        ? user.last_seen == "Online"
                          ? $t("chat.online")
                          : last_time(user.last_seen)
                        : ""
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <p
            v-if="getPlan.show_online == 'off'"
            style="
              text-align: center;
              font-size: 12px;
              margin-top: 25px;
              line-height: 1.1rem;
            "
          >
            <span
              style="text-decoration: underline; cursor: pointer"
              @click="openUpgradePlan"
              >{{ $t("chat.upgrade_now") }}
            </span>
            <span v-html="$t('chat.upgrade_now_last_text')"></span>
          </p>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from "vuex";
import File from "../utils/aws";
import { EventEmitter } from "../main";
import moment from "moment";
import TaskBody from "../views/TaskBody.vue";
import ChatMessages from "../components/chats/ChatMessages.vue";
import MenuAction from "../components/chats/MenuAction.vue";
import Tasks from "../components/tasks/Tasks.vue";
import RenameElement from "../components/app/RenameElement.vue";
import ChatContextMenu from "../components/chats/ChatContextMenu.vue";

import Comments from "../components/comment/Comments.vue";
import AddComment from "../components/comment/AddComment.vue";
import Image from "../assets/static/images/tasks_body.jpg";

export default {
  name: "Chats",
  data() {
    return {
      users: [],
      delayedClassName: false,
      chat: {},
      message: "",
      bool: false,
      files: [],
      local_files: [],
      edit_message: "",
      reply_message: "",
      watch: false,
      project: "",
      show_member:
        localStorage.getItem(this.$route.params.chat_id) == "true"
          ? true
          : false,
      precent_loader: {},
      typingUsers: [],
      mute: {
        bool: false,
        svg: `
                    <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.33332 12.3333V7.66667C1.33332 7.35725 1.45624 7.0605 1.67503 6.84171C1.89382 6.62292 2.19057 6.5 2.49999 6.5H5.64649C5.87694 6.50005 6.10225 6.43185 6.29399 6.304L11.1858 3.042C11.3617 2.92467 11.5661 2.85732 11.7773 2.84717C11.9885 2.83702 12.1984 2.88444 12.3847 2.98436C12.5711 3.08429 12.7267 3.23296 12.8351 3.41449C12.9434 3.59602 13.0004 3.80359 13 4.015V15.985C13 16.1962 12.9427 16.4035 12.8342 16.5847C12.7256 16.7659 12.5699 16.9142 12.3837 17.0139C12.1975 17.1135 11.9877 17.1607 11.7767 17.1505C11.5657 17.1402 11.3615 17.0729 11.1858 16.9557L6.29399 13.6948C6.10212 13.5674 5.87682 13.4996 5.64649 13.5H2.49999C2.19057 13.5 1.89382 13.3771 1.67503 13.1583C1.45624 12.9395 1.33332 12.6428 1.33332 12.3333V12.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                        <path d="M18.25 4.75C18.25 4.75 20 6.5 20 9.41667C20 12.3333 18.25 14.0833 18.25 14.0833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21.75 1.25C21.75 1.25 24.6667 4.16667 24.6667 9.41667C24.6667 14.6667 21.75 17.5833 21.75 17.5833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    `,
        text: this.$t("list.mute"),
      },
      sidebarWidth: 30,
      sidebarPrevious: 0,
      isResizeing: false,
      hasProject: false,
      minSidebarWidth: 400,
      animationName: "1",
      chatBarAnimationName: "1",
      localName: "",
      linkListChatSubmitting: false,
      style: "",
      maxWidth: "auto",
    };
  },
  computed: {
    ...mapGetters([
      "getChats",
      "getUserData",
      "getKnownUsers",
      "getRender",
      "getProjects",
      "getRenderKnownUsers",
      "getPlan",
      "get_active_task_window",
    ]),
    background_image() {
      return this.$store.state.key.background_image;
    },
    background_images() {
      let image = this.$store.state.key.background_images.find(
        (e) => e.image_name == this.$store.state.key.background_image
      );
      if (image) {
        return image.color ? image.color : false;
      } else {
        return false;
      }
    },
    background_image_url_state() {
      return this.$store.state.key.background_image_url;
    },
    sidebarUnitOfMesurement() {
      if (this.sidebarWidth == this.minSidebarWidth) return "px";
      return "%";
    },
  },
  components: {
    ChatMessages,
    MenuAction,
    Tasks,
    RenameElement,
    TaskBody,
    Comments,
    AddComment,
    ChatContextMenu,
  },
  watch: {
    getRenderKnownUsers() {
      this.render(this.$route.params.chat_id);

      this.createChat();
      // setTimeout(() => {
      //     this.render(this.$route.params.chat_id)
      // }, 2000);
    },
    $route(to, from) {
      if (from.params.chat_id !== to.params.chat_id) {
        this.animationName = "1";

        setTimeout(() => {
          this.animationName = "content-push";
        }, 200);
        setTimeout(() => {
          this.show_member =
            localStorage.getItem(this.$route.params.chat_id) == "true"
              ? true
              : false;
          document.getElementById("add_comment_block_chat").focus();
        }, 0);
      }

      this.message = "";
      if (
        document.querySelector(
          ".comments_block .comment_guest .comment_date span"
        ) &&
        document.querySelector(".comments_block > .comment_date span")
      ) {
        if (
          document.querySelector(
            ".comments_block .comment_guest .comment_date span"
          ).innerHTML ==
          document.querySelector(".comments_block > .comment_date span")
            .innerHTML
        ) {
          document.querySelector(
            ".comments_block .comment_guest .comment_date span"
          ).style.display = "none";
        }
        setTimeout(() => {
          if (
            document.querySelector(
              ".comments_block .comment_guest .comment_date span"
            ) &&
            document.querySelector(".comments_block > .comment_date span")
          ) {
            if (
              document.querySelector(
                ".comments_block .comment_guest .comment_date span"
              ).innerHTML ==
              document.querySelector(".comments_block > .comment_date span")
                .innerHTML
            ) {
              document.querySelector(
                ".comments_block .comment_guest .comment_date span"
              ).style.display = "none";
            }
          }
        }, 500);
        setTimeout(() => {
          EventEmitter.$emit("typing_render");
        }, 100);
      }

      // console.log(document.querySelector('.comments_block > .comment_date span'))
      // console.log(document.querySelector('.comments_block .comment_guest .comment_date span'))
      // this.getChats.forEach((chat) => {
      //   chat.users.forEach((user) => {
      //     if (user.user_id == this.getUserData._id) {
      //       if (user.unread_number > 0) {
      //         this.read_msg();
      //       }
      //     }
      //   });
      // });

      this.render(this.$route.params.chat_id);

      // document.querySelector(".chat__bottom textarea").focus();

      this.set_active_task_window(to.params.task_id);

      const taskInputValue = document.getElementById("add_comment_block_list")
        ? document.getElementById("add_comment_block_list").value
        : "";
      const chatInputValue = document.getElementById(
        "add_comment_block_chat"
      ).value;
      if (from.params.chat_id) {
        sessionStorage.setItem(
          "inputValuesOnRouteChange",
          JSON.stringify({
            taskInputValue,
            chatInputValue,
            time: new Date().getTime(),
            chat_id: from.params.chat_id,
          })
        );
      }
    },
    getRender(e) {
      if (this.bool) {
        this.bool = false;
      }
      console.log("getRender");
      this.renderUsersLists();
      // this.render(this.$route.params.chat_id)
    },
    chat: {
      handler(newVal) {
        this.localName = newVal.name;
        if (!this.chat.users) return;
        if (this.hasProject != newVal.project_id) {
          this.hasProject = newVal.project_id;
        } else if (!newVal.project_id) {
          this.hasProject = false;
        }
        this.chat.users.some((user) => {
          if (user.user_id == this.getUserData._id) {
            this.sidebarWidth =
              user.sidebar_width < 400 ? 400 : user.sidebar_width;
            this.sidebarPrevious = this.sidebarWidth;
            this.maxWidth =
              window.innerWidth -
              (document.querySelector(".projects").clientWidth + 400);
            this.style = `width: ${this.sidebarWidth}px; min-width: 400px; max-width: ${this.maxWidth}px`;
            return true;
          }
        });
      },
      deep: true,
    },
  },
  mounted() {
    this.localName = this.chat.name;
    this.animationName = "content-push";
    setTimeout(() => {
      if (document.querySelector(".main-content")) {
        // document.querySelector('.main-content').classList.add('chat-background')
        // let image_url = this.background_image_url_state ? this.background_image_url_state : require('@/assets/static/images/bg/' + this.background_image)
        // document.querySelector('.main-content').style.backgroundImage = `url("${image_url}")`
        // if (this.background_image == 'Taj Mahal.jpg' || this.background_image == 'Kalon.jpg') {
        //   document.querySelector('.main-content').style.backgroundPosition = `top, right`
        // } else {
        //   document.querySelector('.main-content').style.backgroundPosition = `bottom, right`
        // }
      }
    }, 10);
    EventEmitter.$on("linkedProjectInChat", () => {
      this.chatBarAnimationName = "chat-bar";

      setTimeout(() => {
        this.chatBarAnimationName = "1";
      }, 300);
    });
    EventEmitter.$on("LinkListChatSubmitting", ({ chat_id, value }) => {
      if (chat_id == this.$route.params.chat_id) {
        this.linkListChatSubmitting = value;
      }
    });
    EventEmitter.$on("LinkListChatSuccess", ({ chat_id, list_id }) => {
      if (chat_id != this.$route.params.chat_id) return;

      this.linkListChatSubmitting = false;

      if (!list_id) {
        this.$router.push("/chats/" + chat_id).catch(() => {});
      }
    });

    window.addEventListener("mouseup", this.stopResizeFunc);
    setTimeout(() => {
      if (document.getElementById("add_comment_block_chat")) {
        document.getElementById("add_comment_block_chat").focus();
      }
    }, 0);
    EventEmitter.$on("chatSidebarWidthChange", (data) => {
      if (this.chat._id == data.chat_id) this.sidebarWidth = data.sidebar_width;
      this.sidebarPrevious = this.sidebarWidth;
    });

    EventEmitter.$on("chatMuted", ({ chat_id, muted }) => {
      if (chat_id == this.$route.params.chat_id) {
        if (muted) {
          this.mute = {
            bool: true,
            svg: `
                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.1667 7.99999L22.5 10.3333M17.8333 10.3333L20.1667 7.99999L17.8333 10.3333ZM22.5 5.66666L20.1667 7.99999L22.5 5.66666ZM20.1667 7.99999L17.8333 5.66666L20.1667 7.99999Z" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1.5 10.3333V5.66667C1.5 5.35725 1.62292 5.0605 1.84171 4.84171C2.0605 4.62292 2.35725 4.5 2.66667 4.5H5.81317C6.04362 4.50005 6.26893 4.43185 6.46067 4.304L11.3525 1.042C11.5284 0.924666 11.7328 0.857323 11.944 0.847171C12.1552 0.837019 12.3651 0.88444 12.5514 0.984365C12.7377 1.08429 12.8934 1.23296 13.0018 1.41449C13.1101 1.59602 13.1671 1.80359 13.1667 2.015V13.985C13.1667 14.1962 13.1094 14.4035 13.0009 14.5847C12.8923 14.7659 12.7366 14.9142 12.5504 15.0139C12.3642 15.1135 12.1544 15.1607 11.9434 15.1505C11.7324 15.1402 11.5282 15.0729 11.3525 14.9557L6.46067 11.6948C6.2688 11.5674 6.0435 11.4996 5.81317 11.5H2.66667C2.35725 11.5 2.0605 11.3771 1.84171 11.1583C1.62292 10.9395 1.5 10.6428 1.5 10.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                            </svg>
                            `,
            text: this.$t("list.unmute"),
          };
        } else {
          this.mute = {
            bool: false,
            svg: `<svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.33332 12.3333V7.66667C1.33332 7.35725 1.45624 7.0605 1.67503 6.84171C1.89382 6.62292 2.19057 6.5 2.49999 6.5H5.64649C5.87694 6.50005 6.10225 6.43185 6.29399 6.304L11.1858 3.042C11.3617 2.92467 11.5661 2.85732 11.7773 2.84717C11.9885 2.83702 12.1984 2.88444 12.3847 2.98436C12.5711 3.08429 12.7267 3.23296 12.8351 3.41449C12.9434 3.59602 13.0004 3.80359 13 4.015V15.985C13 16.1962 12.9427 16.4035 12.8342 16.5847C12.7256 16.7659 12.5699 16.9142 12.3837 17.0139C12.1975 17.1135 11.9877 17.1607 11.7767 17.1505C11.5657 17.1402 11.3615 17.0729 11.1858 16.9557L6.29399 13.6948C6.10212 13.5674 5.87682 13.4996 5.64649 13.5H2.49999C2.19057 13.5 1.89382 13.3771 1.67503 13.1583C1.45624 12.9395 1.33332 12.6428 1.33332 12.3333V12.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                                <path d="M18.25 4.75C18.25 4.75 20 6.5 20 9.41667C20 12.3333 18.25 14.0833 18.25 14.0833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.75 1.25C21.75 1.25 24.6667 4.16667 24.6667 9.41667C24.6667 14.6667 21.75 17.5833 21.75 17.5833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>`,
            text: this.$t("list.mute"),
          };
        }
      }
    });

    setTimeout(() => {
      this.delayedClassName = true;
    }, 100);

    if (this.$route.params.task_id) {
      this.set_active_task_window(this.$route.params.task_id);
    } else {
      this.set_active_task_window("");
    }

    window.addEventListener("blur", () => {
      this.set_active_task_window("");
    });

    window.addEventListener("focus", () => {
      if (this.$route.params.task_id) {
        this.set_active_task_window(this.$route.params.task_id);
        // this.socket_read_message({
        //   task_id: this.get_active_task_window,
        //   user_id: this.getUserData._id,
        //   // chat_id: comment_id,
        //   all_read: true,
        //   project_id: this.$route.params.project_id,
        // });
      }
    });

    setInterval(() => {
      this.getChats.forEach(async (chat) => {
        // console.log(chat._id, this.$route.params.chat_id)
        if (chat._id == this.$route.params.chat_id) {
          if (chat.users.length > 0) {
            // chat.users.sort( function (a, b) {
            //     return a.last_seen - b.last_seen
            // })
            // chat.users = chat.users.reverse()
            await chat.users.forEach((user, i) => {
              if (this.getUserData._id != user.user_id) {
                if (user.last_seen) {
                  chat.users[i].time =
                    user.last_seen == "Online"
                      ? this.$t("chat.online")
                      : this.last_time(user.last_seen);

                  if (user.last_seen == "Online") {
                    chat.users[i].order = 1;
                  } else {
                    chat.users[i].order = 2;
                  }
                }
              }
              if (this.getUserData._id == user.user_id) {
                chat.users[i].time = this.$t("chat.online");
                chat.users[i].order = 0;
              }
            });
          }
          this.chat = [];
          this.chat = chat;
        }
      });
    }, 60000);

    // setTimeout(() => {
    this.render(this.$route.params.chat_id);
    // console.log(1)
    // this.read_msg();
    // console.log(localStorage.getItem(this.$route.params.chat_id))
    // this.show_member = localStorage.getItem(this.$route.params.chat_id)
    // document.querySelector(".chat__bottom textarea").focus();
    // }, 100)

    // let chat__content = this.$refs.chat__content.$el;
    // if (chat__content) {
    //   setTimeout(() => {
    //     chat__content.scrollTo(0, chat__content.scrollHeight);
    //   }, 150);
    // }

    // EventEmitter.$on("edit_message", (msg) => {
    //   this.edit_message = msg;
    //   this.message = msg.message;
    //   document.querySelector(".chat__bottom textarea").focus();
    // });
    // EventEmitter.$on("reply_message", (msg) => {
    //   this.reply_message = msg;
    //   document.querySelector(".chat__bottom textarea").focus();
    // });
    EventEmitter.$on("closeProjectLists", () => {
      this.watch = false;
      EventEmitter.$emit("sendMessageChatPanelStatus", false);
    });
    EventEmitter.$on("AddUser2TypingList", (chat_id, user_id) => {
      // this.getProjects.forEach((list) => {
      //     if (list._id == list_id) {
      //         this.project = list
      //         localStorage.setItem('project_id', list_id);
      //     }
      // })
      let user_name = "";
      if (this.$route.params.chat_id == chat_id) {
        this.getChats.forEach((chat) => {
          if (chat._id == chat_id) {
            chat.users.forEach((user) => {
              if (user.user_id == user_id) {
                user_name = user.user_data.name;
              }
            });
          }
        });
      }

      if (user_name != "" && !this.typingUsers.includes(user_name)) {
        this.typingUsers.push(user_name);
      }
    });
    EventEmitter.$on("RemoveUserFromTypingList", (chat_id, user_id) => {
      let user_name = "";
      this.getChats.forEach((chat) => {
        if (chat._id == chat_id) {
          chat.users.forEach((user) => {
            if (user.user_id == user_id) {
              user_name = user.user_data.name;
            }
          });
        }
      });
      if (user_name != "" && this.typingUsers.includes(user_name)) {
        let _new_users = [];
        this.typingUsers.forEach((user) => {
          if (user_name != user) {
            _new_users.push(user);
          }
        });
        this.typingUsers = _new_users;
      }
    });
    EventEmitter.$on("ChatAddList", (list_id) => {
      // console.log('List added to chat')
      // console.log('off loader')
      // this.messageBoxLoader(false)
      let list = this.getProjects.filter((l) => l._id == list_id);
      // this.getProjects.forEach((list) => {
      //     if (list._id == list_id) {
      //         this.project = list
      //         localStorage.setItem('project_id', list_id);
      //     }
      // })
      this.project = list[0];
      localStorage.setItem("project_id", list_id);
      EventEmitter.$emit("sendMessageChatPanelStatus", true);
      if (!list_id) {
        this.hasProject = false;
        return;
      }
      if (this.hasProject !== list_id) {
        this.hasProject = list_id;
      }
    });
    EventEmitter.$on("ChatLastSeen", (data) => {
      // let found_user = document.getElementById('user_' + data.user_id)

      // if (found_user) {
      //     found_user.innerHTML = data.time == 'Online' ? 'Online': this.last_time(data.time)
      //     found_user.style = data.time != 'Online' ? 'color: #8C8A8A;': ''
      // }

      this.getChats.forEach(async (chat) => {
        if (chat._id == this.$route.params.chat_id) {
          if (chat.users.length > 0) {
            // chat.users.sort( function (a, b) {
            //     return a.last_seen - b.last_seen
            // })
            // chat.users = chat.users.reverse()
            await chat.users.forEach((user, i) => {
              if (this.getUserData._id != user.user_id) {
                if (user.last_seen) {
                  chat.users[i].time =
                    user.last_seen == "Online"
                      ? this.$t("chat.online")
                      : this.last_time(user.last_seen);

                  if (user.last_seen == "Online") {
                    chat.users[i].order = 1;
                  } else {
                    chat.users[i].order = 2;
                  }
                }
              }
              if (this.getUserData._id == user.user_id) {
                chat.users[i].time = this.$t("chat.online");
                chat.users[i].order = 0;
              }
            });
          }
          this.chat = [];
          this.chat = chat;
        }
      });
    });
    // EventEmitter.$on('addUserChat', (data) => {
    //     console.log(1111111111111)
    //     if (this.chat._id == data.chat_id) {
    //         let isUser = this.chat.users.filter(e => e.user_id == data.users._id)
    //         console.log(isUser)
    //         if (isUser.length == 0) {
    //             this.chat.users.push({
    //                 user_id: data.users._id,
    //                 // user_email: data.users.email,
    //                 last_seen: data.users.last_seen,
    //                 user_data: data.users
    //             })
    //         }
    //         console.log(this.chat)
    //     }
    // })
  },
  methods: {
    ...mapMutations([
      "render",
      "setMessage",
      "setAddMessages",
      "set_active_task_window",
    ]),
    ...mapActions(["connectSocket", "socket_read_message"]),
    renderUsersLists() {
      if (!this.chat) this.users = [];
      if (!this.chat.users) this.users = [];
      let users = this.chat.users.sort((a, b) => {
        if ((a.last_seen == "Online") == b.last_seen) {
          return new Date() - new Date();
        } else if (a.last_seen === "Online") {
          return b.last_seen - new Date();
        } else if (b.last_seen === "Online") {
          return new Date() - a.last_seen;
        } else {
          return b.last_seen - a.last_seen;
        }
      });
      let currentUserIdx = users.findIndex(
        (user) => user.user_id == this.getUserData._id
      );
      const currentUser = users[currentUserIdx];
      users.splice(currentUserIdx, 1);
      users.unshift(currentUser);
      this.users = users;
    },
    openUpgradePlan() {
      EventEmitter.$emit("openSettingPlan", true);
    },
    saveNewName() {
      const temp = this.localName.trim();
      if (temp.length !== 0 && temp !== this.chat.name) {
        this.$socket.emit("IN_RenameChats", {
          chat_name: temp,
          chat_id: this.chat._id,
        });
      } else {
        this.localName = this.chat.name;
      }
    },
    removefocus() {
      this.$refs.chatNameInput.blur();
    },
    afterTransition() {
      EventEmitter.$emit("afterTransition", true);
    },
    handleClickOnResize() {
      if (this.isResizeing) {
        window.removeEventListener("mousemove", this.resizeHelper);
        if (this.sidebarPrevious != this.sidebarWidth) {
          this.setMessage({
            key_message: "warning",
            message: this.$t("app.saved"),
          });
          localStorage.setItem(
            "chat_width_" + this.$route.params.chat_id,
            document.querySelector(".chat_bar").style.width
          );
          this.$socket.emit("IN_ChatChangeSidebar", {
            chat_id: this.chat._id,
            sidebar_width: this.sidebarWidth,
          });
        }
        this.sidebarPrevious = this.sidebarWidth;
      } else {
        window.addEventListener("mousemove", this.resizeHelper);
      }
      this.isResizeing = !this.isResizeing;
    },
    resizeHelper(e) {
      EventEmitter.$emit("WindowResizeChat", true);

      let width = window.innerWidth - e.clientX;
      let chat_width = document.querySelector(".chat").clientWidth;

      if (this.show_member) {
        width = width - this.$refs.members.clientWidth;
      }

      if (chat_width <= 400) {
        this.maxWidth = !this.maxWidth
          ? width
          : width > this.maxWidth
          ? this.maxWidth
          : width;
        this.sidebarWidth = this.maxWidth;
        this.style = `width: ${this.maxWidth}px; min-width: 400px; max-width: ${this.maxWidth}px`;
      } else {
        width = !this.maxWidth
          ? width
          : width > this.maxWidth
          ? this.maxWidth
          : width;
        this.sidebarWidth = width < 400 ? 400 : width;
        this.style = `width: ${
          width < 400 ? 400 : width
        }px; min-width: 400px; max-width: ${this.maxWidth}px`;
      }

      EventEmitter.$emit("chatBarResize", true);

      // EventEmitter.$emit('WindowResizeChat', true)

      // let chat_width = document.querySelector('.chat').clientWidth

      // let width = window.innerWidth - e.clientX
      // let minWidthInPercent = this.minSidebarWidth / this.$refs.chatContent.clientWidth * 100

      // if (this.show_member) {
      //     width = width - this.$refs.members.clientWidth
      //     minWidthInPercent -= this.$refs.members.clientWidth
      // }

      // if (width < this.minSidebarWidth) {
      //     // this.sidebarWidth = this.minSidebarWidth
      //     // this.sidebarWidth = 90 - minWidthInPercent
      //     this.sidebarWidth = width / this.$refs.chatContent.clientWidth * 100
      //     console.log(0)
      // } else {
      //     if (this.sidebarWidth == this.minSidebarWidth) {
      //         if (this.sidebarWidth > 637) return
      //         this.sidebarWidth = width / this.$refs.chatContent.clientWidth * 100
      //     } else {
      //         if (this.sidebarWidth > 50) return
      //         this.sidebarWidth = width / this.$refs.chatContent.clientWidth * 100
      //         // if (this.sidebarWidth > 90 - minWidthInPercent) {
      //             // this.sidebarWidth = 90 - minWidthInPercent
      //         // }
      //     }
      // }

      // EventEmitter.$emit('chatBarResize', true)
    },
    handleStartResize(e) {
      this.handleClickOnResize();
    },
    handleStopResize(e) {
      console.log(0);
      this.handleClickOnResize();
    },
    stopResizeFunc() {
      this.isResizeing = true;
      this.handleClickOnResize();
    },
    newLine(e) {
      if (!e.target.value) return;
      e.target.value += "\n";
      this.setHeightToTextarea(e.target);
    },
    isChatOwner(_user_id) {
      let result = null;
      this.getChats.forEach((chat) => {
        if (chat._id == this.$route.params.chat_id) {
          result = chat.auth == _user_id;
        }
      });
      return result;
    },
    // messageBoxLoader(status)
    // {
    //     let box = document.querySelectorAll('.chat__content')
    //     if (box.length)
    //     {
    //         if (status)
    //         {
    //             box[0].classList.add('loading')
    //         }
    //         else
    //         {
    //             box[0].classList.remove('loading')
    //         }
    //     }
    // },
    read_msg() {
      // let id = [];
      // this.getChats.forEach((chat) => {
      //   if (chat._id == this.$route.params.chat_id) {
      //     // chat.messages.forEach((msg) => {
      //     //     if (msg.user_id != this.getUserData._id) {
      //     //         id.push(msg._id)
      //     //     }
      //     // })
      //     chat.users.forEach((user) => {
      //       if (user.user_id == this.getUserData._id) {
      //         if (user.unread_number) {
      //           if (user.unread_number > 0) {
      //             chat.messages.forEach((msg) => {
      //               if (msg.user_id != this.getUserData._id) {
      //                 id.push(msg._id);
      //               }
      //             });
      //           }
      //         }
      //       }
      //     });
      //   }
      // });
      // // console.log(id[id.length - 1])
      // if (id.length > 0) {
      //   // alert('read')
      //   this.$socket.emit(
      //     "IN_ReadMessages",
      //     this.$route.params.chat_id,
      //     id[id.length - 1]
      //   );
      // }
    },
    muteOrUnmute() {
      if (!this.mute.bool) {
        this.changeMuteStatus(true);
        this.mute = {
          bool: true,
          svg: `
                        <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M20.1667 7.99999L22.5 10.3333M17.8333 10.3333L20.1667 7.99999L17.8333 10.3333ZM22.5 5.66666L20.1667 7.99999L22.5 5.66666ZM20.1667 7.99999L17.8333 5.66666L20.1667 7.99999Z" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M1.5 10.3333V5.66667C1.5 5.35725 1.62292 5.0605 1.84171 4.84171C2.0605 4.62292 2.35725 4.5 2.66667 4.5H5.81317C6.04362 4.50005 6.26893 4.43185 6.46067 4.304L11.3525 1.042C11.5284 0.924666 11.7328 0.857323 11.944 0.847171C12.1552 0.837019 12.3651 0.88444 12.5514 0.984365C12.7377 1.08429 12.8934 1.23296 13.0018 1.41449C13.1101 1.59602 13.1671 1.80359 13.1667 2.015V13.985C13.1667 14.1962 13.1094 14.4035 13.0009 14.5847C12.8923 14.7659 12.7366 14.9142 12.5504 15.0139C12.3642 15.1135 12.1544 15.1607 11.9434 15.1505C11.7324 15.1402 11.5282 15.0729 11.3525 14.9557L6.46067 11.6948C6.2688 11.5674 6.0435 11.4996 5.81317 11.5H2.66667C2.35725 11.5 2.0605 11.3771 1.84171 11.1583C1.62292 10.9395 1.5 10.6428 1.5 10.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                        </svg>
                        `,
          text: this.$t("list.unmute"),
        };
      } else {
        this.changeMuteStatus(false);
        this.mute = {
          bool: false,
          svg: `
                        <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.33332 12.3333V7.66667C1.33332 7.35725 1.45624 7.0605 1.67503 6.84171C1.89382 6.62292 2.19057 6.5 2.49999 6.5H5.64649C5.87694 6.50005 6.10225 6.43185 6.29399 6.304L11.1858 3.042C11.3617 2.92467 11.5661 2.85732 11.7773 2.84717C11.9885 2.83702 12.1984 2.88444 12.3847 2.98436C12.5711 3.08429 12.7267 3.23296 12.8351 3.41449C12.9434 3.59602 13.0004 3.80359 13 4.015V15.985C13 16.1962 12.9427 16.4035 12.8342 16.5847C12.7256 16.7659 12.5699 16.9142 12.3837 17.0139C12.1975 17.1135 11.9877 17.1607 11.7767 17.1505C11.5657 17.1402 11.3615 17.0729 11.1858 16.9557L6.29399 13.6948C6.10212 13.5674 5.87682 13.4996 5.64649 13.5H2.49999C2.19057 13.5 1.89382 13.3771 1.67503 13.1583C1.45624 12.9395 1.33332 12.6428 1.33332 12.3333V12.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                            <path d="M18.25 4.75C18.25 4.75 20 6.5 20 9.41667C20 12.3333 18.25 14.0833 18.25 14.0833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            <path d="M21.75 1.25C21.75 1.25 24.6667 4.16667 24.6667 9.41667C24.6667 14.6667 21.75 17.5833 21.75 17.5833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                        </svg>
                        `,
          text: this.$t("list.mute"),
        };
      }
    },
    changeMuteStatus(status) {
      this.$socket.emit("IN_MutedChats", {
        chat_id: this.$route.params.chat_id,
        muted: status ? true : false,
      });
    },
    setCurrentMuteStatus() {
      if (window.localStorage.getItem("mutedObjectsChat")) {
        let oldMutedObjects = window.localStorage
          .getItem("mutedObjectsChat")
          .split(",");
        if (oldMutedObjects.includes(this.chat._id)) {
          this.mute = {
            bool: true,
            svg: `
                            <svg width="24" height="16" viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M20.1667 7.99999L22.5 10.3333M17.8333 10.3333L20.1667 7.99999L17.8333 10.3333ZM22.5 5.66666L20.1667 7.99999L22.5 5.66666ZM20.1667 7.99999L17.8333 5.66666L20.1667 7.99999Z" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M1.5 10.3333V5.66667C1.5 5.35725 1.62292 5.0605 1.84171 4.84171C2.0605 4.62292 2.35725 4.5 2.66667 4.5H5.81317C6.04362 4.50005 6.26893 4.43185 6.46067 4.304L11.3525 1.042C11.5284 0.924666 11.7328 0.857323 11.944 0.847171C12.1552 0.837019 12.3651 0.88444 12.5514 0.984365C12.7377 1.08429 12.8934 1.23296 13.0018 1.41449C13.1101 1.59602 13.1671 1.80359 13.1667 2.015V13.985C13.1667 14.1962 13.1094 14.4035 13.0009 14.5847C12.8923 14.7659 12.7366 14.9142 12.5504 15.0139C12.3642 15.1135 12.1544 15.1607 11.9434 15.1505C11.7324 15.1402 11.5282 15.0729 11.3525 14.9557L6.46067 11.6948C6.2688 11.5674 6.0435 11.4996 5.81317 11.5H2.66667C2.35725 11.5 2.0605 11.3771 1.84171 11.1583C1.62292 10.9395 1.5 10.6428 1.5 10.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                            </svg>
                            `,
            text: this.$t("list.unmute"),
          };
        } else {
          this.mute = {
            bool: false,
            svg: `
                            <svg width="26" height="19" viewBox="0 0 26 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.33332 12.3333V7.66667C1.33332 7.35725 1.45624 7.0605 1.67503 6.84171C1.89382 6.62292 2.19057 6.5 2.49999 6.5H5.64649C5.87694 6.50005 6.10225 6.43185 6.29399 6.304L11.1858 3.042C11.3617 2.92467 11.5661 2.85732 11.7773 2.84717C11.9885 2.83702 12.1984 2.88444 12.3847 2.98436C12.5711 3.08429 12.7267 3.23296 12.8351 3.41449C12.9434 3.59602 13.0004 3.80359 13 4.015V15.985C13 16.1962 12.9427 16.4035 12.8342 16.5847C12.7256 16.7659 12.5699 16.9142 12.3837 17.0139C12.1975 17.1135 11.9877 17.1607 11.7767 17.1505C11.5657 17.1402 11.3615 17.0729 11.1858 16.9557L6.29399 13.6948C6.10212 13.5674 5.87682 13.4996 5.64649 13.5H2.49999C2.19057 13.5 1.89382 13.3771 1.67503 13.1583C1.45624 12.9395 1.33332 12.6428 1.33332 12.3333V12.3333Z" stroke="#FF8686" stroke-width="1.3"/>
                                <path d="M18.25 4.75C18.25 4.75 20 6.5 20 9.41667C20 12.3333 18.25 14.0833 18.25 14.0833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M21.75 1.25C21.75 1.25 24.6667 4.16667 24.6667 9.41667C24.6667 14.6667 21.75 17.5833 21.75 17.5833" stroke="#FF8686" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            `,
            text: this.$t("list.mute"),
          };
        }
      }
    },
    openBar(chat_id) {
      let bool = !this.show_member;

      if (document.querySelector(".chat_bar")) {
        if (bool) {
          localStorage.setItem(
            "chat_width_" + this.$route.params.chat_id,
            document.querySelector(".chat_bar").style.width
          );
          if (document.querySelector(".chat").clientWidth <= 400 + 237) {
            let width = document.querySelector(".chat_bar").style.width;
            width = Number(width.replace("px", ""));
            if (width > 400) {
              document.querySelector(".chat_bar").style.width =
                width - 237 + "px";
            }
          }
          if (this.maxWidth != "auto") {
            this.maxWidth = this.maxWidth - 237;
          }
        } else {
          if (document.querySelector(".chat").clientWidth >= 400) {
            let width = document.querySelector(".chat_bar").style.width;
            width = Number(width.replace("px", ""));
            if (width > 400) {
              document.querySelector(".chat_bar").style.width =
                localStorage.getItem(
                  "chat_width_" + this.$route.params.chat_id
                );
            }
          }
          if (this.maxWidth != "auto") {
            this.maxWidth = this.maxWidth + 237;
          }
        }
      }

      this.show_member = !this.show_member;

      localStorage.setItem(chat_id, this.show_member);
      EventEmitter.$emit("sendMessageChatPanelStatus", !this.show_member);
      setTimeout(() => {
        // EventEmitter.$emit("sendMessageChatPanelStatus", !this.show_member)
        EventEmitter.$emit("WindowResizeChat", true);
      }, 500);
    },
    delete_edit_message() {
      this.edit_message = "";
      this.message = "";
    },
    delete_reply_message() {
      this.reply_message = "";
      this.message = "";
    },
    removeProjectChats() {
      if (this.linkListChatSubmitting) return;

      EventEmitter.$emit("requestLinkListChat", {
        list_id: "",
        chat_id: this.$route.params.chat_id,
      });
    },
    addProjectChats() {
      if (this.linkListChatSubmitting) return;

      this.watch = true;
      EventEmitter.$emit("openProjectsList", this.chat);
    },
    last_time(e) {
      return moment(Number(e) - 5000)
        .locale(this.$i18n.locale)
        .fromNow();
      let result = "",
        date = new Date(),
        now = date.getTime(),
        time = parseInt((now - e) / 1000),
        minutes = Math.ceil(time / 60),
        hours = parseInt(minutes / 60),
        prefix = " " + this.$t("activity_log.last_time.ago");

      let days = Math.round(time / 3600 / 24);

      if (days >= 92) {
        result = this.$t("activity_log.last_time.few_months");
      } else if (days >= 62) {
        result = this.$t("activity_log.last_time.two_months");
      } else if (days >= 31) {
        result = this.$t("activity_log.last_time.month");
      } else if (days >= 21)
        result = this.$t("activity_log.last_time.three_weeks");
      else if (days >= 14) {
        result = this.$t("activity_log.last_time.two_weeks");
      } else if (days >= 7) {
        result = this.$t("activity_log.last_time.week");
      } else if (days >= 2) {
        result = days + " " + this.$t("activity_log.last_time.days");
      } else if (hours >= 24) {
        result = this.$t("activity_log.last_time.one_day");
      } else if (hours >= 2) {
        result = hours + " " + this.$t("activity_log.last_time.hours");
      } else if (hours == 1) {
        result = this.$t("activity_log.last_time.one_hour");
      } else if (minutes > 2) {
        result = minutes + " " + this.$t("activity_log.last_time.minutes");
      } else if (time > 60) {
        result = this.$t("activity_log.last_time.one_minute");
      } else {
        prefix = "";
        result = this.$t("activity_log.last_time.just_now");
      }

      return result + prefix;
    },
    render(chat_id) {
      this.chat = [];
      // console.log(1111111)
      this.getChats.forEach(async (chat) => {
        if (chat._id == chat_id) {
          // console.log(chat)
          // console.log('ppppppppp')
          // Запись данных пользователей в сообшенния
          // await chat.messages.forEach((e, i) => {
          //   chat.messages[i].send = false;
          //   chat.messages[i].class = "";

          //   if (e.files) {
          //     if (e.files.length > 0) {
          //       let width =
          //         e.files[0].imgWidth > 200 ? 200 : e.files[0].imgWidth;
          //       let w = e.files[0].imgWidth
          //         ? Number(width) + 16
          //         : Number(e.files[0].filename.length) * 7 + 55;
          //       chat.messages[i].width = w;
          //     }
          //   }

          //   if (this.getUserData._id == e.user_id) {
          //     chat.messages[i].user = this.getUserData;
          //   } else {
          //     this.getKnownUsers.forEach((know_user) => {
          //       if (know_user) {
          //         if (know_user._id == e.user_id) {
          //           chat.messages[i].user = know_user;
          //         }
          //       }
          //     });
          //   }
          //   if (e.reply) {
          //     chat.messages.forEach((msg) => {
          //       if (msg._id == e.reply) {
          //         chat.messages[i].reply = msg;
          //       }
          //     });
          //   }
          // });

          // Запись данных пользователей в Members
          if (chat.users.length > 0) {
            // chat.users.sort( function (a, b) {
            //     return a.last_seen - b.last_seen
            // })
            // chat.users = chat.users.reverse()
            await chat.users.forEach((user, i) => {
              if (this.getUserData._id != user.user_id) {
                if (user.last_seen) {
                  chat.users[i].time =
                    user.last_seen == "Online"
                      ? this.$t("chat.online")
                      : this.last_time(user.last_seen);
                  if (user.last_seen == "Online") {
                    chat.users[i].order = 1;
                  } else {
                    chat.users[i].order = 2;
                  }
                }
              }
              if (this.getUserData._id == user.user_id) {
                chat.users[i].user_data = this.getUserData;
                chat.users[i].email = this.getUserData.email;
                chat.users[i].time = this.$t("chat.online");
                chat.users[i].order = 0;
              } else {
                this.getKnownUsers.forEach((know_user) => {
                  if (know_user) {
                    if (know_user._id == user.user_id) {
                      chat.users[i].user_data = know_user;
                      chat.users[i].email = know_user.email;
                    }
                  }
                });
              }
            });
            // console.log(chat.users)
          }
          // await chat.messages.map((e, i, comments) => {
          //   if (i == 0) {
          //     chat.messages[i].date_for_chat = this.$w_date_parse(e.date);
          //   } else {
          //     if (
          //       !comments[i - 1] ||
          //       this.$w_date_parse(e.date) ==
          //         this.$w_date_parse(comments[i - 1].date)
          //     ) {
          //       chat.messages[i].date_for_chat = "";
          //     } else {
          //       chat.messages[i].date_for_chat = this.$w_date_parse(e.date);
          //     }
          //   }

          //   if (chat.messages.length > i + 1) {
          //     if (comments[i + 1].user_id) {
          //       if (e.date_for_chat && i != 0) {
          //         chat.messages[i - 1].avatar = e.user.name[0];
          //       }
          //       if (e.user_id == comments[i + 1].user_id) {
          //         chat.messages[i].avatar = "";
          //       } else {
          //         if (e.user) {
          //           chat.messages[i].avatar = e.user.name[0];
          //         }
          //       }
          //     }
          //   }

          //   if (chat.messages.length == i + 1) {
          //     if (e.user.name) {
          //       chat.messages[chat.messages.length - 1].avatar = e.user.name[0];
          //     }
          //   }
          //   // console.log('-----------')
          //   if (i != 0) {
          //     chat.messages[i].hide =
          //       chat.messages[i - 1].user.name === e.user.name;
          //   } else {
          //     chat.messages[i].user.hide = false;
          //   }
          // });

          chat.user_length = chat.users.length;

          this.getProjects.forEach((p) => {
            if (p._id == chat.project_id) {
              this.project = p;
              localStorage.setItem("project_id", p._id);
            }
          });

          this.chat = chat;
          this.renderUsersLists();

          // set mute status
          this.setCurrentMuteStatus();
        }
      });
    },
    addUser() {
      console.log("adding user!");
      this.$root.$emit("addRenameChatsAddUser", this.chat);
    },
    removeInputFile(i) {
      this.files.splice(i, 1);
    },
    createChat() {
      const monthNames = this.$t("comment.months");

      let auth = "";

      let date = new Date(this.chat.date);

      let min = String(date.getMinutes());

      let task_created =
        date.getDate() +
        " " +
        monthNames[date.getMonth()] +
        " " +
        date.getFullYear();
      // let task_created = date.getDate() + ' ' + date.getUTCMonth() + ' ' + date.getFullYear()
      // console.log(date.getMonth())
      let task_created_time = "";
      // console.log(this.getUserData.date_format)
      if (this.getUserData.date_format) {
        task_created_time = this.$w_time_parse(
          date,
          this.getUserData.date_format.time
        );
      }

      // if (min[1] == undefined) {
      //     task_created_time = date.getHours() + ':0' + date.getMinutes()
      // } else {
      //     task_created_time = date.getHours() + ':' + date.getMinutes()
      // }

      if (this.getUserData._id == this.chat.auth) {
        auth = this.getUserData.name;
      } else {
        this.getKnownUsers.forEach((know_user) => {
          if (know_user._id == this.chat.auth) {
            auth = know_user.name;
          }
        });
      }

      return this.$t("comment.created_task_date", {
        user_name: auth,
        task_created: task_created,
        task_created_time: task_created_time,
      });
    },
    previewFiles(event) {
      if (window.navigator.onLine) {
        this.files = [];
        this.local_files = [];
        let fileObj = {};
        let local_fileObj = {};
        let files = Array.from(event.target.files);
        files.forEach((e) => {
          let nameArr = e.name.split(".");

          let id = this.$w_decrypt(this.getUserData._id);

          fileObj = {
            _id: id,
            filename: e.name,
            ext: nameArr[1],
            size: e.size,
            file: e,
            loader: 0,
          };
          local_fileObj = {
            _id: id,
            filename: e.name,
            ext: nameArr[1],
            size: e.size,
            file: e,
            loader: 0,
          };

          const reader = new FileReader();

          reader.onload = (ev) => {
            fileObj.base64 = ev.target.result;
            local_fileObj.base64 = ev.target.result;
            const img = new Image();
            img.onload = function () {
              const precentOfWidth =
                  this.width > 200 ? 200 / (this.width / 100) : this.width,
                height =
                  this.width > 200
                    ? (this.height / 100) * precentOfWidth
                    : this.height,
                width = this.width > 200 ? 200 : this.width;

              fileObj.imgWidth = this.width;
              fileObj.imgHeight = Math.floor(height);
              local_fileObj.imgWidth = this.width;
              local_fileObj.imgHeight = Math.floor(height);
            };
            img.src = ev.target.result;
          };

          reader.readAsDataURL(e);

          this.files.push(fileObj);
          this.local_files.push(local_fileObj);
        });
        // console.log(this.files)
        document.querySelector(".chat__bottom textarea").focus();
      } else {
        this.setMessage({
          key_message: "file length",
          message: this.$t("app.messages.offline_no_send_file"),
        });
      }
    },
    add_file_loader(file_id, precent) {
      this.precent_loader[file_id] = precent;
      this.$root.$emit("file_onload", this.precent_loader);
    },
    clear_file_loader(file_id) {
      this.precent_loader[file_id] = 101;
      this.$root.$emit("file_onload", this.precent_loader);
    },
    async checkTyping(e) {
      if (e.key != "Enter" || e.keyCode != 13) {
        let textarea = document.querySelector(".chat__bottom textarea");

        if (this.message.trim()) {
          let old_message = this.message;
          if (!textarea.classList.contains("typing_on")) {
            if (this.chat._id) {
              textarea.classList.add("typing_on");
              this.$socket.emit("IN_ChatStartTyping", {
                chat_id: this.chat._id,
              });
            }
          }

          setTimeout(() => {
            // console.log('old_message', old_message.trim())
            // console.log('new message', textarea.value)
            if (
              old_message.trim() == textarea.value ||
              (old_message.trim() != "" && textarea.value == "")
            ) {
              if (this.chat._id) {
                this.$socket.emit("IN_ChatEndTyping", {
                  chat_id: this.chat._id,
                });
                textarea.classList.remove("typing_on");
              }
            }
          }, 2000);
        }
      }
    },
    async sendMessage(event) {
      if (event.shiftKey === true && event.key === "Enter") {
        return;
      }

      if (!this.message.trim()) {
        if (this.files.length == 0) {
          this.message = "";
          return;
        }
      }

      if (this.edit_message) {
        this.$socket.emit(
          "IN_RenameMessages",
          this.chat._id,
          this.edit_message._id,
          this.message
        );
        this.delete_edit_message();
        return false;
      }

      this.connectSocket();

      let message = "";
      let message2 = "";

      if (this.reply_message) {
        message = {
          _id: this.$w_decrypt(this.getUserData._id),
          message: this.message,
          user_id: this.getUserData._id,
          user: this.getUserData,
          date: new Date(),
          reply: this.reply_message,
          // send: true,
          files: this.local_files,
        };
        message2 = {
          _id: this.$w_decrypt(this.getUserData._id),
          message: this.message,
          user_id: this.getUserData._id,
          user: this.getUserData,
          date: new Date(),
          reply: this.reply_message,
          // send: true,
          files: this.files,
        };
        this.delete_reply_message();
      } else {
        message = {
          _id: this.$w_decrypt(this.getUserData._id),
          message: this.message,
          user_id: this.getUserData._id,
          user: this.getUserData,
          date: new Date(),
          // send: true,
          files: this.local_files,
        };
        message2 = {
          _id: this.$w_decrypt(this.getUserData._id),
          message: this.message,
          user_id: this.getUserData._id,
          user: this.getUserData,
          date: new Date(),
          // send: true,
          files: this.files,
        };
      }

      // if (this.chat.messages[this.chat.messages.length - 1].user_id == this.getUserData._id) {
      //     this.chat.messages[this.chat.messages.length - 1].class = 'fixed'
      // }

      let messages = {
        chat_id: this.chat._id,
        messages: message,
      };

      this.setAddMessages(messages);
      EventEmitter.$emit("sendMessageChat", messages);

      // this.chat.messages.push(message)

      // setTimeout(() => {
      //   // let chat__content = this.$refs.chat__content.$el;
      //   chat__content.scrollTo(0, chat__content.scrollHeight);
      // }, 10);

      // message.files.forEach((e, i) => {
      //     message.files[i].base64 = ''
      // })

      this.message = "";
      this.bool = true;

      let files = [];
      const promise1 = new Promise(async (resolve, reject) => {
        if (this.local_files.length > 0) {
          await this.local_files.forEach(async (e) => {
            if (
              e.ext.toLowerCase() == "png" ||
              e.ext.toLowerCase() == "jpg" ||
              e.ext.toLowerCase() == "jpeg"
            ) {
              if (e.imgWidth > 200) {
                let sizes = [200, "full"];

                for await (let size of sizes) {
                  await this.$w_resizeImg(size, e.file, async (base64) => {
                    let file = new File(base64);
                    const uploadRequest = await file.write(
                      "Chats" +
                        "/" +
                        this.chat._id +
                        "/" +
                        size +
                        "__" +
                        e._id +
                        "__" +
                        e.filename
                    );

                    uploadRequest.on("httpUploadProgress", (event) => {
                      let progressPercentage = Math.round(
                        (event.loaded / event.total) * 100
                      );
                      // console.log(progressPercentage)
                      this.add_file_loader(e._id, progressPercentage - 1);
                    });

                    uploadRequest.send((err) => {
                      if (err) {
                        console.log(
                          "UPLOAD ERROR: " + JSON.stringify(err, null, 2)
                        );
                        console.log("FAILURE!!");
                      } else {
                        this.clear_file_loader(e._id);
                        console.log("done");
                        if (size == "full") {
                          files.push(e);
                        }
                      }
                    });
                  });
                }
              } else {
                let file = new File(e.file);
                const uploadRequest = await file.write(
                  "Chats" +
                    "/" +
                    this.chat._id +
                    "/" +
                    e._id +
                    "__" +
                    e.filename
                );

                uploadRequest.on("httpUploadProgress", (event) => {
                  let progressPercentage = Math.round(
                    (event.loaded / event.total) * 100
                  );
                  // console.log(progressPercentage)
                  this.add_file_loader(e._id, progressPercentage - 1);
                });

                uploadRequest.send((err) => {
                  if (err) {
                    console.log(
                      "UPLOAD ERROR: " + JSON.stringify(err, null, 2)
                    );
                    console.log("FAILURE!!");
                  } else {
                    this.clear_file_loader(e._id);
                    console.log("done");
                    files.push(e);
                  }
                });
              }
              resolve(true);
            } else {
              let file = new File(e.file);
              const uploadRequest = await file.write(
                "Chats" + "/" + this.chat._id + "/" + e._id + "__" + e.filename
              );

              uploadRequest.on("httpUploadProgress", (event) => {
                let progressPercentage = Math.round(
                  (event.loaded / event.total) * 100
                );
                // console.log(progressPercentage)
                this.add_file_loader(e._id, progressPercentage - 1);
              });

              uploadRequest.send((err) => {
                if (err) {
                  console.log("UPLOAD ERROR: " + JSON.stringify(err, null, 2));
                  console.log("FAILURE!!");
                } else {
                  this.clear_file_loader(e._id);
                  console.log("done");
                  files.push(e);
                  resolve(true);
                }
              });
            }
          });
        } else {
          resolve(false);
        }
      });

      promise1.then(async (data) => {
        if (data) {
          // alert(0)
          setTimeout(async () => {
            await message2.files.forEach((e, i) => {
              message2.files[i].base64 = "";
              message2.files[i].file = "";
            });
            this.files = [];
            this.local_files = [];
            await this.$socket.emit("IN_AddMessages", message2, this.chat._id);
          }, 1000);
        } else {
          // await message.files.forEach((e, i) => {
          //     message.files[i].base64 = ''
          //     message.files[i].file = ''
          // })
          // this.files = []
          this.files = [];
          this.local_files = [];
          this.$socket.emit("IN_AddMessages", message2, this.chat._id);
        }
      });

      this.files = [];
      // this.local_files = []

      // }
      // this.message = ''
    },
  },
  beforeDestroy() {
    window.removeEventListener("mouseup", this.stopResizeFunc);
  },
};
</script>
